import "./SideBar.css";
import React, { useContext, useState } from "react";
import SideListItem from "../../../Molecules/SideListItem/SideListItem";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import LocationCityRoundedIcon from "@mui/icons-material/LocationCityRounded";
import AutoStoriesRoundedIcon from "@mui/icons-material/AutoStoriesRounded";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { userContext } from "../../../../Contexts/userContext";
import PaymentIcon from "@mui/icons-material/Payment";
import PersonIcon from "@mui/icons-material/Person";
import LooksOneIcon from "@mui/icons-material/LooksOne";
import LooksTwoIcon from "@mui/icons-material/LooksTwo";
import Looks3Icon from "@mui/icons-material/Looks3";
import Looks4Icon from "@mui/icons-material/Looks4";
import Looks5Icon from "@mui/icons-material/Looks5";
import Looks6Icon from "@mui/icons-material/Looks6";
import NumbersIcon from "@mui/icons-material/Numbers";
import { useLocation, useParams } from "react-router-dom";

function SideBar({ setShowMenu }) {
  const { contextData, setContextData } = useContext(userContext);
  const location = useLocation();

  return (
    <div className="SideBar" id="SideBar">
      <ul className="TabList">
        <SideListItem
          name={"account"}
          Pathname={"/"}
          title="Account"
          icon={<AccountCircleIcon className="ListIcon" />}
          setShowMenu={setShowMenu}
        />
        {contextData?.missions
          ?.filter((mission) => mission?.taskType != "discussion")
          ?.map((mission) => (
            <SideListItem
              name={mission?.name}
              Pathname={`/mission/${mission?.id}`}
              title={mission?.name}
              icon={
                mission?.order == 1 ? (
                  <LooksOneIcon className="ListIcon" />
                ) : mission?.order == 2 ? (
                  <LooksTwoIcon className="ListIcon" />
                ) : mission?.order == 3 ? (
                  <Looks3Icon className="ListIcon" />
                ) : mission?.order == 4 ? (
                  <Looks4Icon className="ListIcon" />
                ) : mission?.order == 5 ? (
                  <Looks5Icon className="ListIcon" />
                ) : mission?.order == 6 ? (
                  <Looks6Icon className="ListIcon" />
                ) : (
                  <NumbersIcon className="ListIcon" />
                )
              }
              setShowMenu={setShowMenu}
              active={
                location?.pathname?.split("/mission/")?.at(1) == mission?.id
              }
            />
          ))}
      </ul>
    </div>
  );
}

export default SideBar;
